<template>
  <transition name="fade">
    <div class="loginModal" v-if="show" :class="{fromGame: fromGame}">
      <div class="overlay" v-on:click="close"></div>
      <div :class="{modalContent: true}">
        <div class="close" v-on:click="close"></div>
        <div class="loadingImage" v-if="loading">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <g transform="translate(20 50)">
              <circle cx="0" cy="0" r="6" fill="#1ea5f7" transform="scale(0.97694 0.97694)">
                <animateTransform attributeName="transform" type="scale" begin="-0.375s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g><g transform="translate(40 50)">
              <circle cx="0" cy="0" r="6" fill="#1ea5f7" transform="scale(0.918245 0.918245)">
                <animateTransform attributeName="transform" type="scale" begin="-0.25s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g><g transform="translate(60 50)">
              <circle cx="0" cy="0" r="6" fill="#1ea5f7" transform="scale(0.618706 0.618706)">
                <animateTransform attributeName="transform" type="scale" begin="-0.125s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g><g transform="translate(80 50)">
              <circle cx="0" cy="0" r="6" fill="#1ea5f7" transform="scale(0.269344 0.269344)">
                <animateTransform attributeName="transform" type="scale" begin="0s"
                  calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                  keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
              </circle>
            </g>
          </svg>
        </div>
        <Login v-on:close="close" :fromGame="fromGame" :isDbs="isDbs"></Login>
      </div>
    </div>
  </transition>
</template>

<script>
import Login from '@/components/Login.vue';

export default {
  components: { Login },
  props: {
  },
  data() {
    return {
      show: false,
      loading: false,
      next: null,
      fromGame: false,
      isDbs: false,
    };
  },
  methods: {
    close(ok) {
      this.show = false;
      document.querySelector('body').classList.remove('ofw-hdn');
      if (this.next) this.next(ok);
    },
    open(f, n) {
      this.next = n;
      this.fromGame = f && f.from === 'game';
      this.isDbs = f && f.isDbs;
      this.show = true;
      document.querySelector('body').classList.add('ofw-hdn');
    },
  },
};
</script>

<style scoped lang="scss">
  .loadingImage{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: rgba(255,255,255,.7);
    z-index: 9997;
    border-radius: 20px;
    svg{
      width: 100px;
      position: absolute;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .loginModal{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9991;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    padding: 40px 0;

    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,.5);
      z-index: 1;
    }
    .modalContent{
      position: relative;
      z-index: 2;
      background-color: #fff;
      // background-color: #e6e1c1;
      // background-image: url(../assets/modal-bg.jpg);
      background-size: auto 100%;
      background-position: right;
      background-repeat: no-repeat;
      margin: auto;
      border-radius: 5px;
      padding: 60px 60px;
      .close{
        position: absolute;
        right: 10px; top: 10px;
        width: 40px; height: 40px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #e9e9e9;
          opacity: .8;
        }
      }
      @media (max-width: 680px){
        position: absolute;
        top: 50%; left: 10px; right: 10px;
        transform: translateY(-50%);
        font-size: 15px;
        padding: 50px 30px;
      }
    }
    &.fromGame{
      .modalContent{
        background-color: #e6e1c1;
        background-image: url(../assets/modal-bg.jpg);
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
